import { API_URL } from '@/config';

/**
 * Interface pour les tags publics
 */
export interface Tags {
  tag: string;
  count: number;
}

export const tags = {
  async fetchTags(): Promise<Tags[]> {
    const response = await fetch(`${API_URL}/public/tags`);
    if (!response.ok) {
      throw new Error("Erreur lors de la récupération des tags");
    }
    return await response.json();
  },
};
